import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MaterialIcon from 'material-icons-react';
import Modal from 'react-modal';

import './TestDayWarningModal.scss';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
};

const TestDayWarningModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={props.warningModalOpen}
      onRequestClose={props.closeWarningModal}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
      style={customStyles}>
      <div className="test-day-warning-container modal-container">
        <span className="in-active-color">
          <MaterialIcon size="large" icon="error_outline" />
        </span>
        <h4 className="text-center mt-2">{t('common.labels.warning')}:</h4>
        <h4 className="text-center mt-2">{t(props.warningTitle)}</h4>
        <p className="pt-2 pb-2">{t(props.message)}</p>
        <button className="btn btn-action d-block w-100" onClick={props.closeWarningModal}>
          {t('common.labels.back')}
        </button>
        <button className="btn-link mt-2" onClick={props.onSubmit}>
          {t(props.startLabel)}
        </button>
      </div>
    </Modal>
  );
};

TestDayWarningModal.propTypes = {
  warningModalOpen: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  closeWarningModal: PropTypes.func.isRequired,
  message: PropTypes.string,
  startLabel: PropTypes.string,
  warningTitle: PropTypes.string,
};

TestDayWarningModal.defaultProps = {
  warningTitle: 'common.labels.notTestDay',
};

export default TestDayWarningModal;
